/*********************** Custom JS for Boost AI Search & Discovery  ************************/

(function () {
  'use strict';

  /* ── cm ↔ ft/in converter (filter sliders) ── */

  function cmToFtIn(cm) {
    var v = Math.round(parseFloat(cm));
    if (isNaN(v) || v < 0) return cm + '';
    var totalInches = v / 2.54;
    var feet = Math.floor(totalInches / 12);
    var inches = Math.round(totalInches % 12);
    if (inches === 12) { feet++; inches = 0; }
    return feet + "'" + inches + '"';
  }

  function ftInToCm(s) {
    var m = (s || '').match(/^(\d+)'(\d+)"?$/);
    if (!m) return null;
    return Math.round((parseInt(m[1]) * 12 + parseInt(m[2])) * 2.54);
  }

  function isDone(s) { return /\d+'/.test(s || ''); }

  function convertValue(s) {
    if (!/^\s*\d+(\.\d+)?\s*$/.test(s || '')) return null;
    var n = parseFloat(s);
    if (n < 30) return null;
    if (n <= 2000) return cmToFtIn(n);
    return cmToFtIn(n / 100);
  }

  function isWidthLength(group) {
    var id = (group.getAttribute('data-filteroptionid') || '').toLowerCase();
    return id.indexOf('width') !== -1 || id.indexOf('length') !== -1;
  }

  function run() {
    document.querySelectorAll('.boost-sd__filter-option-range-slider').forEach(function (group) {
      if (!isWidthLength(group)) return;
      var walker = document.createTreeWalker(group, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walker.nextNode())) {
        if (isDone(node.nodeValue)) continue;
        if (!node.parentElement || node.parentElement.tagName === 'INPUT') continue;
        var converted = convertValue(node.nodeValue.trim());
        if (converted) node.nodeValue = converted;
      }
      group.querySelectorAll('input').forEach(function (input) {
        if (document.activeElement === input) return;
        if (isDone(input.value)) return;
        var converted = convertValue(input.value.trim());
        if (converted) input.value = converted;
      });
    });
  }

  document.addEventListener('focus', function (e) {
    var input = e.target;
    if (input.tagName !== 'INPUT') return;
    var group = input.closest('.boost-sd__filter-option-range-slider');
    if (!group || !isWidthLength(group)) return;
    var cm = ftInToCm(input.value.trim());
    if (cm) input.value = cm;
  }, true);

  document.addEventListener('blur', function (e) {
    var input = e.target;
    if (input.tagName !== 'INPUT') return;
    var group = input.closest('.boost-sd__filter-option-range-slider');
    if (!group || !isWidthLength(group)) return;
    setTimeout(function () {
      var converted = convertValue(input.value.trim());
      if (converted) input.value = converted;
    }, 300);
  }, true);

  var dragTimer = null;
  function startDrag(e) {
    if (!e.target.closest('.boost-sd__filter-option-range-slider')) return;
    if (dragTimer) return;
    dragTimer = setInterval(run, 80);
  }
  function stopDrag() {
    if (dragTimer) { clearInterval(dragTimer); dragTimer = null; }
    setTimeout(run, 100);
  }

  document.addEventListener('mousedown', startDrag);
  document.addEventListener('mouseup', stopDrag);
  document.addEventListener('touchstart', startDrag, { passive: true });
  document.addEventListener('touchend', stopDrag);

  var attempts = 0;
  var timer = setInterval(function () { run(); if (++attempts >= 60) clearInterval(timer); }, 200);

  new MutationObserver(function (m) {
    if (m.some(function (x) { return x.addedNodes.length > 0; })) run();
  }).observe(document.body, { childList: true, subtree: true });

  ['boost-sd:loaded','boost-sd:updated','boost-sd:filter-rendered',
   'boost-sd:filter-tree-rendered','boost-sd:filter-updated',
   'boost-sd:collection-loaded','boost-sd:search-loaded'
  ].forEach(function (evt) { document.addEventListener(evt, run); });

})();


/* ── Most Loved Pieces: card enhancements ── */

(function () {

  function enhanceCards() {

    /* 1. Subtitle under section title */
    document.querySelectorAll('.boost-sd__recommendation-title').forEach(function (titleEl) {
      if (titleEl.nextElementSibling && titleEl.nextElementSibling.classList.contains('ml-subtitle')) return;
      var sub = document.createElement('span');
      sub.className = 'ml-subtitle';
      sub.textContent = 'One-of-a-kind rugs, ready to ship worldwide';
      titleEl.insertAdjacentElement('afterend', sub);
    });

    /* 2. Title cleanup — handles ( ), -, and | separators */
    document.querySelectorAll('.boost-sd__product-title').forEach(function (el) {
      if (el.dataset.mlDone) return;
      var full = el.textContent.trim();
      if (!full) return;
      el.dataset.mlFull = full; /* keep the full title (e.g. "– Vintage …") for the micro text below */
      var name = '', size = '';

      var parenOpen  = full.indexOf('(');
      var parenClose = full.lastIndexOf(')');
      var pipeIdx    = full.indexOf('|');
      var dashIdx    = full.indexOf(' - ');

      if (parenOpen !== -1 && parenClose !== -1) {
        name = full.substring(0, parenOpen).trimEnd();
        size = full.substring(parenOpen, parenClose + 1);
        el.innerHTML =
          '<span class="ml-title-name">' + name + '</span>' +
          '<span class="ml-title-size"> ' + size + '</span>';
        el.dataset.mlDone = '1';
      } else if (pipeIdx !== -1) {
        name = full.substring(0, pipeIdx).trim();
        el.textContent = name;
        el.dataset.mlDone = '1';
      } else if (dashIdx !== -1) {
        name = full.substring(0, dashIdx).trimEnd();
        el.textContent = name;
        el.dataset.mlDone = '1';
      }
    });

    /* 2. Micro text block under price */
    document.querySelectorAll('.boost-sd__product-price').forEach(function (priceEl) {
      var next = priceEl.nextElementSibling;
      if (next && next.classList.contains('ml-micro')) return;

      var card = priceEl.closest('.boost-sd__product-item, .boost-sd__product-card, [class*="boost-sd__product-item"]');
      var link = card ? card.querySelector('a[href]') : null;
      var href = (link ? link.getAttribute('href') : '').toLowerCase();
      var titleEl = card ? card.querySelector('.boost-sd__product-title') : null;
      var titleText = titleEl ? (titleEl.dataset.mlFull || titleEl.textContent || '') : '';
      var t = titleText.toLowerCase();
      var path = window.location.pathname.toLowerCase();
      var isCustom = href.indexOf('custom') !== -1 || href.indexOf('bespoke') !== -1
                  || t.indexOf('custom') !== -1 || t.indexOf('bespoke') !== -1
                  || path.indexOf('/collections/custom') === 0;

      /* Only vintage rugs are one of a kind. New rugs (woven by our weavers) can be rewoven in other
         sizes, so they must not claim "Only 1 Available". When the type cannot be told from the page,
         fall back to a line that is true for every rug. */
      var kind;
      if (isCustom) kind = 'custom';
      else if (path.indexOf('/collections/vintage') === 0) kind = 'vintage';
      else if (path.indexOf('/collections/new-handmade') === 0 || path === '/collections/new' || path.indexOf('/collections/new/') === 0) kind = 'new';
      else if (t.indexOf('vintage') !== -1) kind = 'vintage';
      else if (t.indexOf('new handmade') !== -1) kind = 'new';
      else kind = 'unknown';

      var micro = document.createElement('div');
      micro.className = 'ml-micro';
      if (kind === 'custom') {
        micro.innerHTML =
          '<p class="ml-shipping">Free Worldwide Shipping</p>' +
          '<p class="ml-scarcity"><span class="ml-scarcity-kind">Made Just for You</span></p>' +
          '<p class="ml-scarcity"><span class="ml-scarcity-urgency">Delivered in 6–8 Weeks</span></p>';
      } else if (kind === 'vintage') {
        micro.innerHTML =
          '<p class="ml-shipping">Free Worldwide Shipping</p>' +
          '<p class="ml-scarcity">' +
            '<span class="ml-scarcity-kind">One of a Kind</span>' +
            '<span class="ml-scarcity-sep"> &bull; </span>' +
            '<span class="ml-scarcity-urgency">Only 1 Available</span>' +
          '</p>';
      } else if (kind === 'new') {
        micro.innerHTML =
          '<p class="ml-shipping">Free Worldwide Shipping</p>' +
          '<p class="ml-scarcity">' +
            '<span class="ml-scarcity-kind">Ready to Ship</span>' +
            '<span class="ml-scarcity-sep"> &bull; </span>' +
            '<span class="ml-scarcity-urgency">Custom Sizes Available</span>' +
          '</p>';
      } else {
        micro.innerHTML =
          '<p class="ml-shipping">Free Worldwide Shipping</p>' +
          '<p class="ml-scarcity"><span class="ml-scarcity-kind">Handmade in Morocco</span></p>';
      }
      priceEl.insertAdjacentElement('afterend', micro);
    });

    /* 3. Hide old inventory status text */
    document.querySelectorAll('.boost-sd__inventory-status').forEach(function (el) {
      el.style.display = 'none';
    });

    /* 4. Force white background on image wrapper */
    document.querySelectorAll(
      '.boost-sd__product-image-wrapper, .boost-sd__product-link-image, .boost-sd__product-link-image > div'
    ).forEach(function (el) {
      el.style.setProperty('background-color', '#ffffff', 'important');
    });

    /* 5. CTA button after product grid */
    document.querySelectorAll(
      '.boost-sd__widget, .boost-sd__recommendation, [class*="boost-sd__widget"]'
    ).forEach(function (widget) {
      if (widget.querySelector('.ml-cta-wrap')) return;
      var grid = widget.querySelector(
        '.boost-sd__product-list, .boost-sd__products, [class*="product-list"], [class*="products-grid"]'
      );
      var anchor = grid || widget.lastElementChild;
      if (!anchor) return;
      var wrap = document.createElement('div');
      wrap.className = 'ml-cta-wrap';
      wrap.innerHTML = '<a href="/collections/in-stock-rugs" class="ml-cta-btn">View All Rugs</a>';
      anchor.insertAdjacentElement('afterend', wrap);
    });
  }

  /* Staggered runs to cover Boost hydration timing */
  [0, 300, 800, 1500, 3000].forEach(function (d) { setTimeout(enhanceCards, d); });

  /* Re-run on every Boost lifecycle event */
  ['boost-sd:loaded','boost-sd:updated','boost-sd:filter-updated',
   'boost-sd:collection-loaded','boost-sd:search-loaded'
  ].forEach(function (evt) { document.addEventListener(evt, enhanceCards); });

  /* MutationObserver catches any Boost re-render */
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        setTimeout(enhanceCards, 50);
        break;
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

})();